import Search from './components/Search.jsx';

export default Search;
